import { Controller } from '@hotwired/stimulus';
import { findNodeUpwardsByClass, traverseUpwardsTo } from '../helpers';

export default class extends Controller {

    initialize() {
        super.initialize();
        this.updateIndexesEvent = (event) => this.updateIndexesCallback(event);
    }

    connect() {
        this.elementTemplate = this.element.querySelector('template');
        this.content = this.element.querySelector('.repeater-content');

        this.element.addEventListener('repeater:update-indexes', this.updateIndexesEvent);
        this.element.addEventListener('dnd:end', this.updateIndexesEvent);
        this.setupRowIndexes();
    }

    updateIndexesCallback(event) {
        event.stopPropagation();
        this.setupRowIndexes();
    }

    setupRowIndexes() {
        this.content.querySelectorAll('[data-input]').forEach((input) => {
            const namePath = [];

            traverseUpwardsTo(input, 'form', (node) => {
                if (node.dataset.inputKey) {
                    namePath.unshift(node.dataset.inputKey);
                }

                if (node.dataset.repeaterKey) {
                    namePath.unshift(Array.from(node.parentElement.children).indexOf(node));
                }
            });

            let name = '';
            let validationName = '';

            namePath.forEach((path, i) => {
                if (String(path).indexOf('[]') !== -1) {
                    name += (i === 0 ? '' : '[') + path.substring(0, path.length - 2) + (i === 0 ? '' : ']') + '[]';
                    validationName += (i === 0 ? '' : '.') + path.substring(0, path.length - 2);
                } else {
                    name += (i === 0 ? '' : '[') + path + (i === 0 ? '' : ']');
                    validationName += (i === 0 ? '' : '.') + path;
                }
            });

            const inputHolder = findNodeUpwardsByClass(input, 'field-holder');

            if (inputHolder) {
                const feedbackElement = inputHolder.querySelector('[data-feedback]');

                if (feedbackElement) {
                    feedbackElement.dataset.feedback = validationName;
                }
            }

            input.name = name;
            input.dataset.input = validationName;
        });
    }

    addRow() {
        this.content.appendChild(this.elementTemplate.content.cloneNode(true));
        this.setupRowIndexes();
    }

    removeRow(event) {
        event.currentTarget.parentNode.parentNode.remove();
        this.setupRowIndexes();
    }

    disconnect() {
        this.element.removeEventListener('repeater:update-indexes', this.updateIndexesEvent);
        this.element.removeEventListener('dnd:end', this.updateIndexesEvent);
        super.disconnect();
    }
}
